import { observer } from "mobx-react";
import React from "react";
import { Title, Modal, Stack, Text, Anchor } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import {
  JsonView,
  allExpanded,
  collapseAllNested,
  darkStyles,
} from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import { MODALS } from "../../helpers/constants";
import _ from "lodash";
import KeyDisplay from "./keyDisplay";
import NodeAlias from "../interactiveData/nodeAlias";
import GuaranteedUptime from "./guaranteedUptime";
import { ARTICLES } from "../../docs/docsIndex";
import { TextWithInfoAndIcon } from "./textWithInfoAndIcon";
import { IconInfoCircle } from "@tabler/icons-react";
import NostrPrivateKeyDisplay from "./nostrPrivateKeyDisplay";

const NodeIdentity = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <>
      <Modal
        opened={cubby.currentModal === MODALS.NODE_IDENTITY}
        onClose={() => {
          cubby.setModal(null);
          cubby.setNostrPrivateKey(null);
        }}
        title={
          <TextWithInfoAndIcon
            text="Node Info"
            articleSlug={ARTICLES.NODE_INFO_AND_ALIAS.slug}
            icon={<IconInfoCircle size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Stack>
          <Text size="sm">
            Your public key, URI, and alias identify your node on the Lightning
            Network.{" "}
          </Text>
          <KeyDisplay
            contextText={cubby.publicKey}
            explanatoryText="node public key"
            infoLink="foo.bar.com"
          />

          {cubby.cubbyInfo?.data?.uris.length > 0 && (
            <KeyDisplay
              contextText={cubby.cubbyInfo?.data?.uris[0]}
              explanatoryText="node URI"
              infoLink="foo.bar.com"
            />
          )}

          <NodeAlias cubby={cubby} />
          <KeyDisplay
            contextText={cubby.nostr_public_key}
            explanatoryText="nostr public key"
            infoLink="foo.bar.com"
          />
          <NostrPrivateKeyDisplay cubby={cubby} />

          <Text size="xs" c="dimmed">
            logged in: {cubby.userEmail}
          </Text>
        </Stack>
      </Modal>
    </>
  );
});

export default NodeIdentity;
